import { cloneElement, ReactElement } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSsoContext } from "contexts/authSSOContext";

const EMPTY_JAVASCRIPT_HREF = "javascript:;";

interface LinkComponentProps {
  href?: string;
  children: string | ReactElement | ReactElement[];
  targetBlack?: boolean;
  onClick?: (e?) => void;
  ariaLabel?: string;
  className?: string;
  shouldLogin?: boolean;
  isChildAnchor?: boolean;
  onMouseOver?: (e?) => void;
  onMouseOut?: (e?) => void;
  target?: string;
  shouldRegister?: boolean;

}

const LinkStrict = ({ children, href = null }) => {
  if (href && href !== EMPTY_JAVASCRIPT_HREF) {
    return (
      //only for real links
      <Link passHref prefetch={false} href={href}>
        {children}
      </Link>
    );
  }
  return children;
};

const LinkComponent = ({
  href,
  children,
  targetBlack,
  onClick,
  ariaLabel,
  shouldLogin = false,
  className = "nexttag",
  isChildAnchor = false,
  onMouseOver,
  onMouseOut,
  target,
  shouldRegister=false,
  ...rest
}: LinkComponentProps) => {
  href = href || EMPTY_JAVASCRIPT_HREF;
  const router = useRouter();
  let onClickWrapper;
  const { loggedInToken, isLoggedInSso, verifiedToken } = useSsoContext();
  const isHrefEmpty = () => {
    return href == EMPTY_JAVASCRIPT_HREF;
  };
  if (shouldRegister && isLoggedInSso) {
    onClickWrapper = (href: string) => (e) => {
      onClick && onClick(e);
      e.preventDefault();
      // LoginMember(
      //     true,
      //     isHrefEmpty() ? window.location.href : href,
      //     LoginAndRegistrationConstants.REGISTER_NEW_USER,
      //     true
      // );
      verifiedToken().then(
        () =>
          (window.location.href = isHrefEmpty() ? window.location.href : href)
      );
    };
  } else if (shouldLogin) {
    onClickWrapper = (href: string) => (e) => {
      onClick && onClick(e);
      if (!isLoggedInSso) {
        e.preventDefault();
        // LoginMember(
        //     true,
        //     isHrefEmpty() ? window.location.href : href,
        //     "",
        //     true,
        //   null,
        //   null,
        //   null
        // );
        loggedInToken().then(
          () =>
            (window.location.href = isHrefEmpty() ? window.location.href : href)
        );
      } else {
        if (target == "_blank") {
          window.open(href, "_blank");
        } else {
          window.location.href = href;
        }
      }
    };
  } else {
    onClickWrapper = () => (e) => {
      onClick && onClick(e);
      return true;
    };
  }
  if (typeof children === "string")
    return (
      <LinkStrict href={shouldLogin ? EMPTY_JAVASCRIPT_HREF : href}>
        <a
          className={className}
          {...rest}
          onClick={onClickWrapper(href)}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          aria-label={ariaLabel}
          data-type-3="true"
          target={target}
        >
          {children}
        </a>
      </LinkStrict>
    );
  if (
    isChildAnchor ||
    // @ts-ignore
    children?.type?.target === "a" ||
    // @ts-ignore
    children?.type === "a"
  ) {
    // @ts-ignore
    const child = cloneElement(children, { onClick: onClickWrapper(href) });
    return (
      <LinkStrict href={(shouldLogin || shouldRegister) ? EMPTY_JAVASCRIPT_HREF : href}>
        {child}
      </LinkStrict>
    );
  }
  // @ts-ignore
  if (children?.type?.target === "button" || children?.type === "button") {
    // @ts-ignore
    const onClickWrapper2 = (e) => {
      if (onClickWrapper(href)(e)) {
        router.push(href);
      }
    };
    // @ts-ignore
    const clonedButton = cloneElement(children, { onClick: onClickWrapper2 });
    return clonedButton;
  }

  return (
    <LinkStrict href={href}>
      <a
        className={className}
        {...rest}
        aria-label={ariaLabel}
        onClick={onClickWrapper(href)}
        target={targetBlack && "_blank"}
      >
        {children}
      </a>
    </LinkStrict>
  );
};

export default LinkComponent;
